import { Box, Button, Image, Link, Text, Checkbox, useToast } from "@chakra-ui/react";
import axios from "axios";
import Loading from "components/Misc/Loading";
import { api } from "config";
import * as React from "react";
import { Coupon, Group } from "types/apiTypes";
import CombankLogos from "assets/img/combank_logos.jpg";
import { Link as RouterLink } from "react-router-dom";

const addScript = (src: any, callback: any) => {
  const isAlreadyAdded = document.querySelector(
    `script[src="${src}"]`,
  ) as HTMLScriptElement;
  if (isAlreadyAdded) return;

  const tag = document.createElement("script");
  tag.type = "text/javascript";
  tag.src = src;
  tag.onload = callback;
  tag.setAttribute("data-error", "errorCallback");
  tag.setAttribute("data-cancel", "cancelCallback");
  document.body.appendChild(tag);
};

interface Props {
  group: Group
  selectedMonthId: number
  setStep: (step: number) => void
  selectedMonthIds: number[]
  isMulti?: boolean
  voucherDetails?: Coupon
  validateVoucher: () => void
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>
  paymentPersonId?: number | null
}

const ComBankPage: React.FC<Props> = ({
  group,
  selectedMonthId,
  selectedMonthIds,
  isMulti,
  voucherDetails,
  setOpenModal,
  paymentPersonId,
}) => {
  const [loadingCS, setLoadingCS] = React.useState(false)
  const [agreed, setAgreed] = React.useState(false)
  const toast = useToast()

  const [clientSecret, setClientSecret] = React.useState<string>("") //session ID/ mastercard

  const getClientSecret = async () => {
    setLoadingCS(true)
    if (!isMulti) selectedMonthIds = [selectedMonthId]
    if (!paymentPersonId) {
      toast({
        title: "Please select a payment person",
        position: "bottom-right",
        status: "warning",
      })
      setLoadingCS(false)
      return
    }

    const response = await axios.get(
      `${api}/payments/get-combank-session?monthids=${selectedMonthIds.join(",")}&coupon=${voucherDetails?.code}&payment_person=${paymentPersonId}`,
      { withCredentials: true },
    )
    if (response.data.result === "SUCCESS") {
      setClientSecret(response.data.session.id)
    }
    setLoadingCS(false)
  }
  const handleComBankPayment = () => {
    setOpenModal(false)
    //@ts-ignore
    Checkout.showPaymentPage()

    // console.log(Checkout);
  }

  React.useEffect(() => {
    getClientSecret()
  }, [])

  React.useEffect(() => {
    if (!clientSecret) return
    window.scrollTo(0, 0)
    const init = () => {
      // const clientSecret = "SESSION0002890526894F30396535M6";
      console.log(clientSecret)
      // @ts-ignore
      Checkout.configure({
        session: {
          id: clientSecret,
        },
      })
    }
    addScript(
      process.env.NODE_ENV === "development"
        ? // ? "https://cbcmpgs.gateway.mastercard.com/checkout/version/71/checkout.js"
          // : "https://cbcmpgs.gateway.mastercard.com/checkout/version/71/checkout.js",
          "https://cbcmpgs.gateway.mastercard.com/static/checkout/checkout.min.js"
        : "https://cbcmpgs.gateway.mastercard.com/static/checkout/checkout.min.js",
      init,
    )
    ;(window as any).errorCallback = (error: any) => {
      console.error("ComBank payment error:", error)
      // Handle the error as needed
    }
    ;(window as any).cancelCallback = (cancel: any) => {
      console.error("ComBank payment cancelled:", cancel)
      // Handle the cancellation as needed
    }
  }, [clientSecret])
  if (loadingCS) {
    return <Loading />
  }

  return (
    <Box my="8" fontFamily={"Lexend"}>
      <Box textAlign={"center"} fontSize="lg">
        Pay securely with{" "}
        <Link
          href="https://www.ComBank.lk/"
          color="blue"
          borderBottom="1px"
          target="_blank"
        >
          <Box display="flex" alignItems="center" justifyContent="center">
            <Image src={CombankLogos} alt="ComBank" width={400} />
          </Box>
        </Link>
        <Text fontWeight={"bold"} color="gray.500" fontSize={"2xl"}>
          {voucherDetails
            ? (group.fee *
                (isMulti ? selectedMonthIds.length : 1) *
                (100 - voucherDetails.percentage)) /
              100
            : group.fee * (isMulti ? selectedMonthIds.length : 1)}{" "}
          Euros
        </Text>
      </Box>
      <Box display={"flex"} justifyContent="center">
        <Checkbox
          isChecked={agreed}
          onChange={(e) => setAgreed(e.target.checked)}
        >
          මම එකඟයි{" "}
          <a href="/admin/terms-and-conditions" target={"_blank"}>
            <Text as="span" color="blue.500" textDecoration="underline">
              Terms and Conditions
            </Text>
          </a>{" "}
          and{" "}
          <a href="/admin/privacy-policy" target={"_blank"}>
            <Text as="span" color="blue.500" textDecoration="underline">
              Privacy Policy
            </Text>
          </a>
          .
        </Checkbox>
      </Box>

      <Box my="6" display="flex" alignItems="center" justifyContent="center">
        <Button
          onClick={handleComBankPayment}
          colorScheme="green"
          disabled={!agreed}
        >
          Click here to Pay Now
        </Button>
      </Box>
    </Box>
  )
}

export default ComBankPage;
